<template>
  <div>

    <code>
      # ┌───────────── minute (0 - 59)
      # │ ┌───────────── hour (0 - 23)
      # │ │ ┌───────────── day of the month (1 - 31)
      # │ │ │ ┌───────────── month (1 - 12)
      # │ │ │ │ ┌───────────── day of the week (0 - 6) (Sunday to Saturday)
      # │ │ │ │ │
      # │ │ │ │ │
      # │ │ │ │ │
      # * * * * *
    </code>
    <div class="my-3">
      <v-card style="max-width: fit-content;">
        <v-card-title class="headline">Define your schedule</v-card-title>
        <v-divider />
        <v-card-text>
          The schedule below is To customize the schedule below, click through its five parameters.
        </v-card-text>

        <!-- <v-card-text class="pa-0">
          <v-item-group v-model="tab" mandatory>
            <v-layout column style="max-width: 1200px;">
              <v-item v-for="(item, key, index) in schedule" :key="index" :value="key">
                <div class="d-flex" slot-scope="{ active, toggle }">
                  <v-card flat :style="{ 'min-width': '200px', 'width': getTextWidth(item.value) }" @click="toggle()">
                    <v-text-field @keydown.space.prevent solo flat hide-details :color="item.isValid ? 'success' : 'error'" v-model="item.value" :class="{'error--text': !item.isValid, 'success--text': active && item.isValid, 'px-2 pt-2 clickable display-1 no-max-height no-default-text': true }" />
                    <div :class="{ 'success--text': active && item.isValid, 'error--text': !item.isValid, 'font-weight-medium': active, 'px-2 pb-2': true }">
                      {{ item.label }}
                    </div>
                  </v-card>
                  <component :is="item.component" v-model="item.value" @isValid="item.isValid = $event" />
                </div>
              </v-item>
            </v-layout>
          </v-item-group>
        </v-card-text> -->

        <v-card-text class="pa-0">
          <v-item-group v-model="tab" mandatory>
            <v-layout style="max-width: 1200px;">
              <v-item v-for="(item, key, index) in schedule" :key="index" :value="key">
                <v-card :style="{ 'min-width': '200px', 'width': getTextWidth(item.value) }" @click="toggle()" slot-scope="{ active, toggle }">
                  <v-text-field @keydown.space.prevent solo flat hide-details :color="item.isValid ? 'success' : 'error'" v-model="item.value" :class="{'error--text': !item.isValid, 'success--text': active && item.isValid, 'px-2 pt-2 clickable display-1 no-max-height no-default-text': true }" />
                  <div :class="{ 'success--text': active && item.isValid, 'error--text': !item.isValid, 'font-weight-medium': active }">
                    <PrimaryBtn :depressed="active" :color="active ? 'success' : ''" block>{{ item.label }}</PrimaryBtn>
                  </div>
                </v-card>
              </v-item>
            </v-layout>
          </v-item-group>
        </v-card-text>
        <v-divider />
        <code :class="{'py-2 px-1 subheading max-width': true, 'success--text': isValid, 'error--text': !isValid }" v-html="cronExplanation" />
        <v-divider />
        <keep-alive>
          <component v-bind:is="schedule[tab].component" v-model="schedule[tab].value" @isValid="schedule[tab].isValid = $event" />
        </keep-alive>
        <v-divider />
        <v-card-actions>
          <PrimaryBtn icon="done">Save</PrimaryBtn>
          <SecondaryBtn color="success" icon="help">Help</SecondaryBtn>
        </v-card-actions>
      </v-card>
    </div>

  </div>
</template>

<script>
  import { calculateTextWidth } from '@/helpers/strings'
  // import cronstrue from 'cronstrue'

  export default {
    data: () => ({
      tab: 'minute',
      schedule: {
        minute: {
          label: 'Minutes',
          value: '*',
          isValid: true,
          component: () => import('@/components/Subcomponents/CronPicker/Minute'),
        },
        hour: {
          label: 'Hours',
          value: '*',
          isValid: true,
          component: () => import('@/components/Subcomponents/CronPicker/Hour'),
        },
        dayMonth: {
          label: 'Days of month',
          value: '*',
          isValid: true,
          component: () => import('@/components/Subcomponents/CronPicker/DaysOfMonth'),
        },
        month: {
          label: 'Months',
          value: '*',
          isValid: true,
          component: () => import('@/components/Subcomponents/CronPicker/Month'),
        },
        dayWeek: {
          label: 'Days of week',
          value: '*',
          isValid: true,
          component: () => import('@/components/Subcomponents/CronPicker/DaysOfWeek'),
        },
      },
    }),
    computed: {
      isValid() {
        return !Object.values(this.schedule).some(item => !item.isValid)
      },
      cronString: {
        get() {
          return Object.values(this.schedule).map(item => item.value || ' ').join(' ').trim()
        },
        set(val) {
          let maybeValues = val.split(' ')
          this.schedule.minute.value = maybeValues[0]
          this.schedule.hour.value = maybeValues[1]
          this.schedule.dayMonth.value = maybeValues[2]
          this.schedule.month.value = maybeValues[3]
          this.schedule.dayWeek.value = maybeValues[4]
        },
      },
      cronExplanation() {
        try {
          // eslint-disable-next-line no-undef
          return cronstrue.toString(this.cronString, { verbose: true })
        } catch (error) {
          console.error('cronexplanation error', error)
          return 'Invalid expression'
        }
      },
    },
    methods: {
      updateValue(tab, newValue) {
        this.schedule[tab].value = newValue
      },
      getTextWidth(text) {
        let val = calculateTextWidth(text, 'bold 34pt Roboto, sans-serif')
        return val + 'px'
      },
    },
  }
</script>